import React from 'react';
import { Trans } from '@lingui/macro';

export default {
  total: (
    <strong>
      <Trans id="general.cart.total" />
    </strong>
  ),
  discountPopover: <Trans id="general.cart.discountPopover" />,
};
